function cellSortValue(cell, sortType) {
  const raw = (cell.dataset.sortValue || cell.textContent || '').trim();
  if (sortType === 'number') {
    const parsed = parseFloat(raw.replace(/,/g, ''));
    return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
  }
  return raw.toLowerCase();
}

function updateIndicators(table, activeButton, direction) {
  table.querySelectorAll('.js-sort-indicator').forEach((indicator) => {
    indicator.textContent = '';
  });

  const activeIndicator = activeButton.querySelector('.js-sort-indicator');
  if (activeIndicator) {
    activeIndicator.textContent = direction === 'asc' ? ' \u2191' : ' \u2193';
  }
}

function sortTable(table, columnIndex, sortType, direction, button) {
  const tbody = table.tBodies[0];
  if (!tbody) return;

  const rows = Array.from(tbody.rows);
  rows.sort((a, b) => {
    const aValue = cellSortValue(a.cells[columnIndex], sortType);
    const bValue = cellSortValue(b.cells[columnIndex], sortType);

    if (aValue < bValue) return direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  rows.forEach((row) => tbody.appendChild(row));
  table.dataset.sortColumn = String(columnIndex);
  table.dataset.sortDirection = direction;
  updateIndicators(table, button, direction);

  document.dispatchEvent(new CustomEvent('reports:table-sorted', {
    detail: {
      tableId: table.id || null,
      columnIndex: columnIndex,
      direction: direction
    }
  }));
}

function initializeSortableTables() {
  document.querySelectorAll('table.js-sortable-table').forEach((table) => {
    if (table.dataset.sortableBound === 'true') return;

    const headerButtons = Array.from(table.querySelectorAll('thead .js-sort-col'));

    headerButtons.forEach((button, index) => {
      button.addEventListener('click', function () {
        const currentColumn = Number.parseInt(table.dataset.sortColumn || '-1', 10);
        const currentDirection = table.dataset.sortDirection || 'asc';
        const sortType = button.dataset.sortType || 'string';

        let nextDirection = 'asc';
        if (currentColumn === index) {
          nextDirection = currentDirection === 'asc' ? 'desc' : 'asc';
        }

        sortTable(table, index, sortType, nextDirection, button);
      });
    });

    table.dataset.sortableBound = 'true';
  });
}

document.addEventListener('DOMContentLoaded', initializeSortableTables);
document.addEventListener('turbo:load', initializeSortableTables);
